import React from "react";
import Button from "../../../utils/components/Button";
import Modal from "../../../utils/components/Modal";
import Input from "../../../utils/components/Input";
import Textarea from "../../../utils/components/Textarea";
import SelectBox from "../../../utils/components/SelectBox";
import { withLocalize } from "react-localize-redux";
import { Helmet } from "react-helmet-async";
import { useOutletContext, useParams } from "react-router";
import API from "../../../utils/API";
import toastr from "toastr";

const CompanyInfo = ({ translate }) => {
  const { setBreadcrumbs, company } = useOutletContext();
  const [projects, setProjects] = React.useState([]);
  const [companyInfo, setCompanyInfo] = React.useState(null);
  const [editedCompanyInfo, setEditedCompanyInfo] = React.useState(null);
  const [selectedProjects, setSelectedProjects] = React.useState([]);
  const [modal, setModal] = React.useState(false);
  const { id } = useParams();

  const handleChange = (e) => {
    setEditedCompanyInfo({
      ...editedCompanyInfo,
      [e.target.name]: e.target.value,
    });
  };

  const updateCompany = (payload) => {
    API.updateCompanyData(payload, id).then(({ data: res }) => {
      if (res.data.name) {
        toastr.success(
          translate(
            "companies.edit-company-modal.messages.company-updated-successfully"
          )
        );
        setCompanyInfo(editedCompanyInfo);
        setModal(false);
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      address: editedCompanyInfo.address,
      email: editedCompanyInfo.email,
      fax: editedCompanyInfo.fax,
      name: editedCompanyInfo.name,
      short_name: editedCompanyInfo.short_name,
      telephone: editedCompanyInfo.telephone,
      web_address: editedCompanyInfo.web_address,
      projects: [],
    };

    selectedProjects.forEach((item) => {
      payload.projects.push(parseInt(item.value));
    });

    updateCompany(payload);
  };

  React.useEffect(() => {
    setCompanyInfo(company);
    setEditedCompanyInfo(company);
    let selectedProjectsList = company?.projects.map((project) => {
      return {
        value: project.id.toString(),
        label: project.name,
      };
    });
    setSelectedProjects(selectedProjectsList);
  }, [company]);

  React.useEffect(() => {
    setBreadcrumbs([
      {
        id: 0,
        title: "page_titles.companies",
        route: "auth.companies",
      },
      { id: 1, customTitle: companyInfo?.name || "" },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyInfo]);

  React.useEffect(() => {
    API.getProjects().then(({ data: res }) => {
      let projectsList = res.data.map((project) => {
        return {
          value: project.id.toString(),
          label: project.name,
        };
      });
      setProjects(projectsList);
    });
  }, []);

  React.useEffect(() => {
    if (!modal) {
    }
  }, [modal]);

  return (
    <div className="CompanyDetailPage CompanyInfo">
      <Helmet>
        <title>{companyInfo?.name || ""}</title>
      </Helmet>
      <header>
        <div className="row align-items-center">
          <div className="col-9">
            <h6 className="page-title m-0">
              {translate("company.company-informations")}
            </h6>
          </div>
          <div className="col-3 d-flex justify-content-end">
            <Button
              className="btn-secondary"
              onClick={() => {
                setModal(true);
              }}
            >
              {translate("edit")}
            </Button>
          </div>
        </div>
      </header>
      <div className="row">
        <div className="col-12">
          <div className="inner-page">
            <div className="row">
              <div className="col">
                <h6 className="info-title">
                  {translate("companies.modal-input-titles.company-name")}
                </h6>
                <p className="info-text">{companyInfo?.name}</p>
              </div>
              <div className="col">
                <h6 className="info-title">
                  {translate("companies.modal-input-titles.company-address")}
                </h6>
                <p className="info-text">{companyInfo?.address}</p>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <h6 className="info-title">
                  {translate("companies.modal-input-titles.company-phone")}
                </h6>
                <p className="info-text">{companyInfo?.telephone}</p>
              </div>
              <div className="col">
                <h6 className="info-title">
                  {translate("companies.modal-input-titles.company-fax-number")}
                </h6>
                <p className="info-text">{companyInfo?.fax}</p>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <h6 className="info-title">
                  {translate("companies.modal-input-titles.company-web-site")}
                </h6>
                <p className="info-text">{companyInfo?.web_address}</p>
              </div>
              <div className="col">
                <h6 className="info-title">
                  {translate("companies.modal-input-titles.company-email")}
                </h6>
                <p className="info-text">{companyInfo?.email}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        title={`Update ${companyInfo?.name}'s information`}
        positiveButtonNode={translate("save")}
        negativeButtonNode={translate("cancel")}
        positiveButtonHandler={handleSubmit}
        modalSize="lg"
        show={modal}
        setShow={(show) => {
          setModal(show);
        }}
      >
        <form onSubmit={handleSubmit}>
          <div className="d-flex flex-wrap align-items-center">
            <div className="col-md-6 mt-2 pe-3">
              <Input
                type="text"
                title={translate("companies.modal-input-titles.company-name")}
                defaultValue={editedCompanyInfo?.name}
                inputProps={{ name: "name" }}
                onChange={handleChange}
                placeholder={translate(
                  "companies.edit-company-modal.placeholders.enter-company-name"
                )}
              />
            </div>
            <div className="col-md-6 mt-4 pe-3">
              <Input
                type="text"
                title={translate(
                  "companies.modal-input-titles.company-short-name"
                )}
                defaultValue={editedCompanyInfo?.short_name}
                inputProps={{ name: "short_name" }}
                onChange={handleChange}
                placeholder={translate(
                  "companies.edit-company-modal.placeholders.enter-company-short-name"
                )}
              />
            </div>
            <div className="col-md-6 mt-4 pe-3">
              <Input
                type="tel"
                title={translate("companies.modal-input-titles.company-phone")}
                defaultValue={editedCompanyInfo?.telephone}
                inputProps={{ name: "telephone" }}
                onChange={handleChange}
                placeholder={translate(
                  "companies.edit-company-modal.placeholders.enter-company-phone-number"
                )}
              />
            </div>
            <div className="col-md-6 mt-4 pe-3">
              <Input
                type="fax"
                title={translate(
                  "companies.modal-input-titles.company-fax-number"
                )}
                defaultValue={editedCompanyInfo?.fax}
                inputProps={{ name: "fax" }}
                onChange={handleChange}
                placeholder={translate(
                  "companies.edit-company-modal.placeholders.enter-company-fax-number"
                )}
              />
            </div>
            <div className="col-md-6 mt-4 pe-3">
              <Input
                type="email"
                title={translate("companies.modal-input-titles.company-email")}
                defaultValue={editedCompanyInfo?.email}
                inputProps={{ name: "email" }}
                onChange={handleChange}
                placeholder="Enter Contact Email"
              />
            </div>
            <div className="col-md-6 mt-4 pe-3">
              <Input
                type="text"
                title={translate(
                  "companies.modal-input-titles.company-web-site"
                )}
                defaultValue={editedCompanyInfo?.web_address}
                inputProps={{ name: "web_address" }}
                onChange={handleChange}
                placeholder={translate(
                  "companies.edit-company-modal.placeholders.enter-company-web-address"
                )}
              />
            </div>
            <div className="col-md-12 mt-4 pe-3">
              <Textarea
                title={translate(
                  "companies.modal-input-titles.company-address"
                )}
                defaultValue={editedCompanyInfo?.address}
                textareaProps={{ name: "address" }}
                onChange={handleChange}
                placeholder={translate(
                  "companies.edit-company-modal.placeholders.enter-company-address"
                )}
                rows={3}
              />
            </div>
            <div className="col-12 mt-4 pe-3">
              <p className="headTitle text-secondary fw-bold mb-1 ms-1">
                {translate("companies.modal-input-titles.projects")}
              </p>
              <SelectBox
                options={projects}
                value={selectedProjects}
                isMulti={true}
                onChange={(e) => {
                  setSelectedProjects(e);
                }}
                placeholder={translate(
                  "companies.edit-company-modal.placeholders.select-projects"
                )}
              />
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default withLocalize(CompanyInfo);
